"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLevelData = getLevelData;
var _uuid = require("uuid");
var _transportLevels = _interopRequireDefault(require("./transportLevels"));
var _energyLevels = _interopRequireDefault(require("./energyLevels"));
var _animationScripts = _interopRequireDefault(require("./animationScripts"));
var _getSvgBackgroundColor = require("./getSvgBackgroundColor");
var _constants = require("../../resources/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var levels = {
  transport: _transportLevels.default,
  energy: _energyLevels.default
};
function getLevelData(co2Range, category, dataSource) {
  var animationID = (0, _uuid.v4)();
  var backgroundColor = (0, _getSvgBackgroundColor.getSvgBackgroundColor)();
  var co2CategoryLevels = levels[category][dataSource];

  // If the co2Range is in the defined levels, use it.
  // Else use the last one
  var co2Levels = co2Range in co2CategoryLevels ? co2CategoryLevels[co2Range] : Object.values(co2CategoryLevels)[Object.values(co2CategoryLevels).length - 1];
  var optionData = co2Levels[Math.floor(Math.random() * co2Levels.length)];
  if (category === _constants.CATEGORY.transport) {
    return Object.assign(optionData, {
      backgroundColor: backgroundColor,
      animationID: animationID,
      animationScript: _animationScripts.default[optionData.vehicle](animationID)
    });
  } else if (category === _constants.CATEGORY.energy) {
    return Object.assign(optionData, {
      backgroundColor: backgroundColor,
      animationID: animationID
    });
  }
  return optionData;
}
//# sourceMappingURL=getLevelData.js.map